/**
 * @generated SignedSource<<7d2ce4bcc80c3934a75ccc3426001b21>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type DevOpsPullRequestStatus = "DECLINED" | "DRAFT" | "MERGED" | "OPEN" | "UNKNOWN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type main_softwareCodePage_FilteredTable$data = ReadonlyArray<{
  readonly author: {
    readonly accountId: string;
  } | null | undefined;
  readonly repositoryId: string | null | undefined;
  readonly reviewers: ReadonlyArray<{
    readonly user: {
      readonly accountId: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly status: DevOpsPullRequestStatus | null | undefined;
  readonly title: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"pullRequestTable_softwareCodePage">;
  readonly " $fragmentType": "main_softwareCodePage_FilteredTable";
}>;
export type main_softwareCodePage_FilteredTable$key = ReadonlyArray<{
  readonly " $data"?: main_softwareCodePage_FilteredTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_FilteredTable">;
}>;

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "accountId"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "main_softwareCodePage_FilteredTable",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": (v0/*: any*/)
    },
    {
      "concreteType": "DevOpsReviewer",
      "kind": "LinkedField",
      "name": "reviewers",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "repositoryId"
    },
    {
      "kind": "FragmentSpread",
      "name": "pullRequestTable_softwareCodePage"
    }
  ],
  "type": "DevOpsPullRequestDetails"
};
})();

(node as any).hash = "23162c5b0920e80a4a4c54114e262d07";

export default node;
